import NavVM from './nav-vm';
import Vue from 'vue';
import 'libs/vue-extensions';
export default {
  init : function(element) {
    let vm = new Vue(NavVM);
    vm.$mount(element);
  }
};
